import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "30",
            height: "30",
            viewBox: "0 0 30 30",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("rect", {
                    width: "30",
                    height: "30",
                    rx: "15",
                    fill: "black"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M16.5 6.02073L22.0263 9.21133C22.9545 9.74722 23.5263 10.7376 23.5263 11.8094V18.1906C23.5263 19.2624 22.9545 20.2528 22.0263 20.7887L16.5 23.9793C15.5718 24.5152 14.4282 24.5152 13.5 23.9793L7.97372 20.7887C7.04552 20.2528 6.47372 19.2624 6.47372 18.1906V11.8094C6.47372 10.7376 7.04552 9.74722 7.97372 9.21132L13.5 6.02073C14.4282 5.48483 15.5718 5.48483 16.5 6.02073Z",
                    fill: "black",
                    stroke: "#FFB21D",
                    strokeWidth: "2"
                })
            ]
        })
    });
};
export default Icon;
